import { Routes } from '@angular/router';

import { publicRouteGuard } from '@guards/public-route.guard';
import { AuthenticationLayoutComponent } from '@layouts/authentication-layout/authentication-layout.component';

/**
 * Authentication feature routes.
 * All routes are protected by publicRouteGuard (redirects authenticated users away).
 */
export const AUTHENTICATION_ROUTES: Routes = [
  {
    path: 'auth',
    component: AuthenticationLayoutComponent,
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('@pages/authentication/login/login.component').then((c) => c.LoginComponent),
        data: { layout: 'blank' },
      },
      {
        path: 'request-access',
        loadComponent: () =>
          import('@pages/authentication/request-access/request-access.component').then(
            (c) => c.RequestAccessComponent,
          ),
        data: { layout: 'blank' },
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('@pages/authentication/forgot-password/forgot-password.component').then(
            (c) => c.ForgotPasswordComponent,
          ),
        data: { layout: 'blank' },
      },
      {
        path: 'update-password/:token',
        loadComponent: () =>
          import('@pages/authentication/update-password/update-password.component').then(
            (c) => c.UpdatePasswordComponent,
          ),
        data: { layout: 'blank' },
      },
    ],
    canActivate: [publicRouteGuard],
  },
];
